export const FILTER_DISCUSSIONS = 'discussion';
export const FILTER_QUESTIONS = 'question';
export const FILTER_SHOW_ALL = '';
